import { requestWithToken } from '../../utilities/request';

/**
 * 企業管理者IDを申請
 * @param {Number} companyId 会社ID
 * @param {object} data：更新データ
 */
const create = (companyId, data) => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/companies/${companyId}/buildee_manager_grant_request`,
    headers: { 'content-type': 'multipart/form-data' },
    data,
  });
};

/**
 * 企業管理者IDを申請
 * @param {Number} companyId 会社ID
 * @param {Number} companyBranchId 支店ID
 */
const fetchBuildeeBanagerGrantRequests = (companyId, companyBranchId) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/companies/${companyId}/company_branches/${companyBranchId}/buildee_manager_grant_requests/list`,
  });
};

export const BuildeeManagerRequestApi = {
  create,
  fetchBuildeeBanagerGrantRequests,
};

export default BuildeeManagerRequestApi;



// WEBPACK FOOTER //
// ./src/services/buildeeManagerRequest/BuildeeManagerRequestApi.js